import { FormControlLabel } from "@mui/material";
import styled from "styled-components";

export const RadioStyled = styled(FormControlLabel)``;
